import { WidgetTabType } from "@lifeat/shared/data-models/widget/WidgetTab/WidgetTabDataModel";
import { ABSTRACT_WIDGET_TAB_NODE, USERS_NODE } from "@lifeat/shared/rtdb-nodes/RtdbNodes";
import { db, functions } from "@firebase-local/firebase";
import { WIDGET_TAB_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";
import { logError } from "@service/ConsoleLoggerService";

/**
 * Marks the selected widget tab as active
 *   @param {string} widgetId - Widget identifier
 *   @param {WidgetTabType} tab - Widget tab data object
 */
export const selectWidgetTab = (widgetId: string, tab: WidgetTabType): void => {
    const data = { widgetId, tab };
    functions
        .httpsCallable(WIDGET_TAB_FUNCTIONS.SelectWidgetTab)(data)
        .then((res: any) => {
            // Successfully selected new widget tab
        })
        .catch((error: any) => {
            logError(
                `There was an error [code: ${error.code}, message: ${error.message}] ` +
                    `when selecting a new widget tab.`,
            );
        });
};

/**
 * Edits the specified widget tab's name
 *   @param {string} widgetId - Widget identifier
 *   @param {WidgetTabType} tab - Widget tab data object
 */
export const editWidgetTabName = (widgetId: string, tab: WidgetTabType) => {
    const data = { widgetId, tab };
    return functions.httpsCallable(WIDGET_TAB_FUNCTIONS.EditWidgetTabName)(data);
};

/**
 * Delete the specified widget tab
 *   @param {string} widgetId - Widget identifier
 *   @param {WidgetTabType} tab - Widget tab data object
 */
export const deleteWidgetTab = (widgetId: string, tab: WidgetTabType) => {
    const data = { widgetId, tab };
    return functions.httpsCallable(WIDGET_TAB_FUNCTIONS.DeleteWidgetTab)(data);
};

/**
 * Create new widget tab
 *   @param {string} widgetId - Widget identifier
 *   @param {WidgetTabType} tab - Widget tab data object
 */
export const createWidgetTab = (widgetId: string, tab: WidgetTabType) => {
    const data = { widgetId, tab };
    return functions.httpsCallable(WIDGET_TAB_FUNCTIONS.CreateWidgetTab)(data);
};

export const updateActiveTabId = (userId: string, widgetId: string, tabId: string) => {
    return db
        .ref(`${USERS_NODE.name}/${userId}/${widgetId}/${ABSTRACT_WIDGET_TAB_NODE.children.ACTIVE_TAB_ID}`)
        .set(tabId);
};
